import { createAPI } from '../../common'
const microservices = '/mediax-admin'
const microservices_ = '/prodb'
const version = 'v1'
import store from '@/store';
function getUserName() {
  try {
    if (store.state.micro.loginInfo.userName) {
      return encodeURI(store.state.micro.loginInfo.userName)
    } else {
      return ''
    }
  } catch (error) {
    console.error(error) 
  }
}
function setConfig(config) {
  return {
    ...(config || {}),
    headers: {
      ...(config?.headers || {}),
      operatorName: getUserName()
    }
  }
}
export default {
  // 获取平台配置
  getBatmanConfig: (config) => createAPI(`${microservices}/batmanConfig/getConfig`, 'get', setConfig(config)),
  // 获取可选稿签
  getArticleLabel: (config) => createAPI(`${microservices}/domLabel/batmanLables`, 'get', setConfig(config)),
  // 保存平台配置
  postBatmanConfig: (config) => createAPI(`${microservices}/batmanConfig/save`, 'post', setConfig(config)),

  getFolder: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60benjo0epn0gpmefs', 'get', config),
  getSubFolder: (config) => createAPI('customEncryptApiName-1/0nfejby.bsujdmffeju0f60benjo0epn0gpmefst', 'get', config),

  // 获取角色下拉选项列表
  getMemberRoleList: (config) => createAPI(`/prodb/member/spc/${version}/role`, 'get', setConfig(config)),
  // 新建会员时账号校验
  getCheckLoginName: (config) => createAPI(`/prodb/member/spc/${version}/app/checkLoginName.do`, 'get', setConfig(config)),
  // 手机号校验
  getCheckMobileExist: (config) => createAPI(`/prodb/member/spc/${version}/baas/member/checkMobileExist`, 'get', setConfig(config)),
  // 邮箱校验
  getCheckEmailExist: (config) => createAPI(`/prodb/member/spc/${version}/baas/member/checkEmailExist`, 'get', setConfig(config)),
  // 新建会员
  postAddMember: (config) => createAPI(`/prodb/member/spc/${version}/allMemberInfo/edit`, 'post', setConfig(config)),

  // 获取SM2公钥
  getPublicKey: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getPublicKey`, 'get', setConfig(config)),
  // 查询平台设置内容
  getSubmissionPlatformConfig: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getSubmissionPlatformConfig`, 'get', setConfig(config)),
  // 保存平台设置内容
  postSaveSubmissionPlatformConfig: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/saveSubmissionPlatformConfig`, 'post', setConfig(config)),
  // 获取分组树
  getSubmissionPlatformGroupTree: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getSubmissionPlatformGroupTree`, 'post', setConfig(config)),
  // 保存分组
  postSaveSubmissionPlatformGroup: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/saveSubmissionPlatformGroup`, 'post', setConfig(config)),
  // 删除分组
  deleteSubmissionPlatformGroup: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/deleteSubmissionPlatformGroup`, 'post', setConfig(config)),
  // 获取投稿平台账号信息列表
  getSubmissionPlatformAccountList: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getSubmissionPlatformAccountList?page=${config.data.page}&size=${config.data.size}`, 'post', setConfig(config)),
  // 移动投稿平台账号
  postMoveSubmissionPlatformAccount: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/moveSubmissionPlatformAccount`, 'post', setConfig(config)),
  // 激活/冻结投稿平台账号
  postAuditSubmissionPlatformAccount: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/auditSubmissionPlatformAccount`, 'post', setConfig(config)),
  // 删除投稿平台账号
  deleteSubmissionPlatformAccount: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/deleteSubmissionPlatformAccount`, 'post', setConfig(config)),
  // 投稿平台查询会员列表
  getMemberList: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getMemberList?page=${config.data.page}&size=${config.data.size}`, 'post', setConfig(config)),
  // 投稿平台保存操作权限配置
  postSaveSubmissionPlatformOperationAuth: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/saveSubmissionPlatformOperationAuth`, 'post', setConfig(config)),
  // 投稿平台获取操作授权配置
  getSubmissionPlatformAuthConfig: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getSubmissionPlatformAuthConfig`, 'post', setConfig(config)),
  // 投稿平台获取操作权限
  getSubmissionPlatformOperationAuth: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getSubmissionPlatformOperationAuth`, 'post', setConfig(config)),
  // 通过会员ID查询投稿平台账号信息
  getSubmissionPlatformAccountByUserId: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/getSubmissionPlatformAccountByUserId`, 'get', setConfig(config)),
  // 保存投稿平台账号信息
  postSaveSubmissionPlatformAccount: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/saveSubmissionPlatformAccount`, 'post', setConfig(config)),
  // 投稿平台账号信息列表导出
  postExportSubmissionPlatformAccount: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/exportSubmissionPlatformAccount`, 'post', setConfig(config)),
  // 投稿平台账号-自媒体-栏目名称是否重复(自动创建的时候用这个)
  postAuditWemediaColumnRepeat: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/auditWemediaColumnRepeat`, 'post', setConfig(config)),
  // 投稿平台账号-自媒体-栏目名称是否重复(当手动选择栏目时调用这个接口)
  postAuditWemediaColumnHasSelect: (config) => createAPI(`${microservices_}/member/spc/${version}/backend/auditWemediaColumnHasSelect`, 'post', setConfig(config)),
}